export default (informations) => ({
  phoneNumber: informations?.phoneNumber || "",
  location: informations?.location || "",
  website: informations?.website || "",
});
